import { useEffect, useState } from 'react';

const BREAKPOINTS = { sm: 640, md: 768, lg: 1024, xl: 1280 } as const;
type ScreenSize = keyof typeof BREAKPOINTS;

export function useBreakpoint(): ScreenSize {
  const [size, setSize] = useState<ScreenSize>('sm');

  useEffect(() => {
    const updateSize = () => {
      const w = window.innerWidth;
      if (w < BREAKPOINTS.sm) setSize('sm');
      else if (w < BREAKPOINTS.md) setSize('md');
      else if (w < BREAKPOINTS.lg) setSize('lg');
      else setSize('xl');
    };
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
}
